<template>
    <div class="android">
        <div class="top">
          <img src="/static/img/i_logo.png" alt="" class="icon">
          <p class="title">海纳视频面试</p>
        </div>
        <div class="color">
            <div class="infos">
                <p class="a1"><img src="/static/img/notice-info.png" alt="" class="icon">为了更好的面试体验</p>
                <p class="a1">请使用电脑浏览器打开链接使用</p>
            </div>
            <div class="box link">
                <p class="info">https://vi.hinapower.cn</p>
                <el-button type="success" style="margin: 10px 0;width: 100%" @click="copy('https://vi.hinapower.cn')">复制面试链接（ <span style="color: #FFEC5D">推荐电脑打开</span> ）</el-button>
                <p style="margin-top: 20px">或者下载海纳视频面试App</p>
                <el-button type="success" size="small" style="margin: 10px 0;width: 100%" @click="downloadApp">立即下载</el-button>
            </div>            
        </div>
        <div class="box code">
            <p class="title">也可以使用微信小程序</p>
            <img :src="staticUrl" alt="" class="logo" />
            <p class="title">长按识别或保存此图片</p>
            <p class="title">微信『扫一扫』中识别小程序码</p>
            <p class="title">快速试用</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            info: {},
            codeUrl: '',
            staticUrl: '/static/img/wechatHina.jpg',
            downloadLink: 'http://www.hinapower.cn/redirect/interviewDownload',
        }
    },
    methods:{
      copy(url){
        let oInput = document.createElement('input')
        oInput.value = url
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        oInput.style.display = 'none'
        document.body.removeChild(oInput)
        this.$message.success('复制链接成功')
      },
      downloadApp(){
          window.location.href = this.downloadLink
      }
    }
}
</script>
<style lang="scss" scoped>
.android{
  p{
    margin: 0;
  }
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    // justify-content: center;
    background: #fff;
    position: relative;
    .top{
      display: flex;
      align-items: center;
      width: 100%;
      position: absolute;
      top: 10px;
      .icon{
        width: 30px;
        height: auto;
        margin: 10px;
        margin-left: 20px;
      }
      .title{
        font-size: 15px;
        color:#2B313A;
      }
    }
    .color{
        background: #e9f8f5;
        padding: 30px 0;
        margin-bottom: 10px;
        margin-top: 80px;
    }
    .infos{
        .a1{
            font-size: 18px;
            color: #2B313A;
            text-align: center;
            .icon{
                width: 16px;
                height: 16px;
                margin-right: 5px;
            }
        }
        .single{
            margin: 20px;
            text-align: center;
            .title{
                color: #8B8F94;
                margin: 8px 0;
            }
            .content{
                color: #3E444C;
                margin: 8px 0;
                font-weight: bold;
            }
        }
    }
    .box{
        padding: 0 40px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        p{
            margin: 0;
        }
        .logo{
            width: 150px;
            height: 150px;
            margin-bottom: 20px;
        }
        .title{
            font-size: 15px;
            color: #8B8F94;
            margin: 4px 0;
        }
        .info{
            padding: 0;
            margin: 6px 0;
            font-size: 16px;
            word-break: break-all;
            color: #3E444C;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/content/onlyPc.vue